// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"ReportProductConsumptionPrint_tableWrap__2J71F"};